import React from 'react';

import './Process.css';
import './Process.mobile.css';


const Process = () => {

    const methodologySections = [
        {
            section_number: '01',
            category_label: 'STRATÉGIE',
            main_title: 'ANALYSE STRATÉGIQUE',
            subtitle_text: 'ET CADRAGE',
            description_paragraph:
                "La réussite d'un projet repose sur la précision de sa définition. Cette phase mobilise mes compétences en Conseil & Stratégie pour évaluer la faisabilité et le retour sur investissement.",
            detail_points: [
                "Compréhension du besoin : Audit de l'existant et identification des leviers de croissance.",
                "Définition des objectifs : Priorisation des fonctionnalités pour une mise sur le marché efficace.",
                "Aide à la décision : Orientation vers les choix technologiques les plus pertinents."
            ]
        },
        {
            section_number: '02',
            category_label: 'LOGIQUE',
            main_title: 'ARCHITECTURE',
            subtitle_text: 'ET MODÉLISATION',
            description_paragraph:
                "Avant tout développement, je structure les fondations du système. L'objectif est la Simplification des Processus complexes pour garantir fluidité et scalabilité.",
            detail_points: [
                "Conception des flux : Modélisation des données et des interactions.",
                "Choix de l'architecture : Sélection d'une stack technique adaptée (Web, Logiciel, IA).",
                "Optimisation opérationnelle : Réduction des frictions dans vos processus métiers."
            ]
        },
        {
            section_number: '03',
            category_label: 'PRODUCTION',
            main_title: 'DÉVELOPPEMENT',
            subtitle_text: 'ET INTÉGRATION',
            description_paragraph:
                "C'est le cœur de la production, alliant Développement Web, Automatisation & IA. Je construis des outils sur mesure, propres et documentés.",
            detail_points: [
                "Ingénierie Logicielle : Création d'applications web, d'API et d'outils performants.",
                "Automatisation Intelligente : Déploiement de workflows et d'agents IA.",
                "Traitement de la Donnée : Mise en place de pipelines de Scraping et collecte structurée."
            ]
        },
        {
            section_number: '04',
            category_label: 'SÉCURITÉ',
            main_title: 'OPTIMISATION',
            subtitle_text: 'ET SÉCURISATION',
            description_paragraph:
                "Une solution fonctionnelle doit également être performante et sécurisée. Je m'assure que les livrables répondent aux standards d'exigence élevés.",
            detail_points: [
                "Performance : Optimisation du code et des requêtes pour une exécution rapide.",
                "Sécurité : Protection des données sensibles et sécurisation des points d'accès.",
                "Tests : Vérification rigoureuse de la stabilité avant le déploiement."
            ]
        },
        {
            section_number: '05',
            category_label: 'DEPLOY',
            main_title: 'LIVRAISON',
            subtitle_text: 'TRANSMISSION ET SUIVI',
            description_paragraph:
                "La livraison marque le début de l'exploitation. Je propose un Support Technique complet et des modules de Formation pour garantir votre autonomie.",
            detail_points: [
                "Déploiement : Mise en production et rédaction de documentation claire.",
                "Traduction Technique : Adaptation des contenus complexes pour vos équipes.",
                "Coaching : Formation pour maîtriser les nouveaux outils et solutions IA.",
                "Maintenance : Suivi proactif et amélioration continue des systèmes."
            ]
        }
    ];


    const productionSteps = methodologySections.slice(0, 4);
    const deliveryStep = methodologySections[4];


    const renderDeliveryPoint = (
        point,
        labelClass,
        textClass
    ) => {

        const separatorIndex = point.indexOf(':');

        if (separatorIndex === -1) {
            return point;
        }

        const label =
            point.slice(
                0,
                separatorIndex + 1
            );

        const description =
            point.slice(
                separatorIndex + 1
            );

        return (
            <>
                <span className={labelClass}>
                    {label}
                </span>

                <span className={textClass}>
                    {description}
                </span>
            </>
        );
    };


    return (

        <section
            className="process-section"
            aria-labelledby="process-title"
        >

            <div className="process-container">


                {/* =================================================
                    HERO
                    ================================================= */}

                <header className="process-hero">

                    <h1
                        id="process-title"
                        className="process-title"
                    >
                        MÉTHODOLOGIE & APPROCHE
                    </h1>


                    <div className="process-hero-intro">

                        <span className="process-hero-intro-label">
                            PROCESSUS
                        </span>


                        <p className="process-hero-intro-text">

                            Construire des

                            <strong>
                                {" "}infrastructures incassables{" "}
                            </strong>

                            à travers un processus structuré,
                            de l'analyse jusqu'à la livraison.

                        </p>

                    </div>

                </header>


                {/* =================================================
                    DESKTOP
                    ================================================= */}

                <div className="process-desktop-layout">


                    {/* =============================================
                        PHASES 01 — 04
                        ============================================= */}

                    <div className="process-desktop-grid">

                        {productionSteps.map(
                            (section) => (

                                <article
                                    key={section.section_number}
                                    className="process-card"
                                >

                                    <header className="process-card-header">

                                        <span className="process-card-number">
                                            {section.section_number}
                                        </span>


                                        <span className="process-card-category">
                                            {section.category_label}
                                        </span>

                                    </header>


                                    <div className="process-card-content">

                                        <h2 className="process-card-title">
                                            {section.main_title}
                                        </h2>


                                        <p className="process-card-subtitle">
                                            {section.subtitle_text}
                                        </p>


                                        <div className="process-card-rule" />


                                        <p className="process-card-description">
                                            {section.description_paragraph}
                                        </p>

                                    </div>

                                </article>

                            )
                        )}

                    </div>


                    {/* =============================================
                        PHASE 05 — DELIVERY
                        ============================================= */}

                    <aside className="process-delivery">

                        <header className="process-delivery-header">

                            <span className="process-delivery-number">
                                {deliveryStep.section_number}
                            </span>


                            <span className="process-delivery-badge">
                                {deliveryStep.category_label}
                            </span>

                        </header>


                        <div className="process-delivery-content">

                            <span className="process-delivery-kicker">
                                PHASE FINALE
                            </span>


                            <h2 className="process-delivery-title">
                                {deliveryStep.main_title}
                            </h2>


                            <p className="process-delivery-subtitle">
                                {deliveryStep.subtitle_text}
                            </p>


                            <div className="process-delivery-rule" />


                            <p className="process-delivery-description">
                                {deliveryStep.description_paragraph}
                            </p>


                            <div className="process-delivery-points">

                                {deliveryStep.detail_points.map(
                                    (point, index) => (

                                        <div
                                            key={index}
                                            className="process-delivery-point"
                                        >

                                            {renderDeliveryPoint(
                                                point,
                                                'process-delivery-point-label',
                                                'process-delivery-point-text'
                                            )}

                                        </div>

                                    )
                                )}

                            </div>

                        </div>

                    </aside>

                </div>


                {/* =================================================
                    MOBILE
                    ================================================= */}

                <div
                    className="process-mobile-track"
                    role="region"
                    aria-label="Étapes de la méthodologie"
                >


                    {/* =============================================
                        SLIDE 01 — PROCESS
                        ============================================= */}

                    <article className="process-mobile-panel process-mobile-panel-steps">

                        <header className="process-mobile-panel-header">

                            <span className="process-mobile-panel-index">
                                01
                            </span>


                            <span className="process-mobile-panel-badge">
                                PROCESS
                            </span>

                        </header>


                        <div className="process-mobile-list">

                            {productionSteps.map(
                                (section) => (

                                    <div
                                        key={`mobile-${section.section_number}`}
                                        className="process-mobile-list-item"
                                    >

                                        <div className="process-mobile-list-heading">

                                            <span className="process-mobile-list-step">
                                                {section.section_number}
                                            </span>


                                            <h2 className="process-mobile-list-title">
                                                {section.main_title}
                                            </h2>

                                        </div>


                                        <p className="process-mobile-list-subtitle">
                                            {section.subtitle_text}
                                        </p>


                                        <p className="process-mobile-list-description">
                                            {section.description_paragraph}
                                        </p>

                                    </div>

                                )
                            )}

                        </div>

                    </article>


                    {/* =============================================
                        SLIDE 02 — DELIVERY
                        ============================================= */}

                    <article className="process-mobile-panel process-mobile-panel-delivery">

                        <header className="process-mobile-panel-header">

                            <span className="process-mobile-panel-index">
                                02
                            </span>


                            <span className="process-mobile-panel-badge">
                                DELIVERY
                            </span>

                        </header>


                        <div className="process-mobile-delivery-content">

                            <span className="process-mobile-delivery-kicker">
                                PHASE 05
                            </span>


                            <h2 className="process-mobile-delivery-title">
                                {deliveryStep.main_title}
                            </h2>


                            <p className="process-mobile-delivery-subtitle">
                                {deliveryStep.subtitle_text}
                            </p>


                            <div className="process-mobile-delivery-rule" />


                            <p className="process-mobile-delivery-description">
                                {deliveryStep.description_paragraph}
                            </p>


                            <div className="process-mobile-delivery-points">

                                {deliveryStep.detail_points.map(
                                    (point, index) => (

                                        <div
                                            key={index}
                                            className="process-mobile-delivery-point"
                                        >

                                            {renderDeliveryPoint(
                                                point,
                                                'process-mobile-delivery-point-label',
                                                'process-mobile-delivery-point-text'
                                            )}

                                        </div>

                                    )
                                )}

                            </div>

                        </div>

                    </article>

                </div>


                {/* =================================================
                    FINAL
                    ================================================= */}

                <footer className="process-final">

                    <span className="process-final-label">
                        MÉTHODOLOGIE
                    </span>


                    <p className="process-final-text">
                        La méthodologie déployée aujourd'hui est conçue
                        pour vos besoins de demain.
                    </p>

                </footer>


            </div>

        </section>

    );
};


export default Process;